import { Redirect, Route, Switch } from 'react-router-dom'
import NotFoundPage from '../404/NotFoundPage'
import { ROUTER_PATH, orderManagerMeta } from './metaData'
import JobManagement from '../job-management'
import ProfileScreen from '../profile'
const OrderManagerRouters = (props: any) => {
   return (
      <Switch>
         <Redirect exact from={`/`} to={orderManagerMeta[0].path} />
         <Route exact path={`${props.match.url}${ROUTER_PATH.JobManagementScreen}`} component={JobManagement} />
         <Route exact path={`${props.match.url}${ROUTER_PATH.ProfileScreen}`} component={ProfileScreen} />
         <Route path="*" component={NotFoundPage} />
      </Switch>
   )
}

export default OrderManagerRouters
